module.exports = __webpack_public_path__ + "static/media/01.jpg.269c71f6.bkp";